const store: IWCStore = window['webComponentsStore'];
import wcShared from '@web-components/shared';

export function createLink(url: string) {
  return store?.productsRouting?.manager + url;
}

export function formatGroupEntity(type: string) {
  switch (type) {
    case 'admin':
      return wcShared?.translate('Administrateur');
    case 'owner':
      return wcShared?.translate('Responsable legal');
    case 'normal':
      return wcShared?.translate('Collaborateur');
    case 'client':
      return wcShared?.translate('Client');
    default:
      return wcShared?.translate('Collaborateur');
  }
}

export function translate(
  text: string,
  params?: object,
  allowedTag?: string[],
  allowedAttr?: string[],
) {
  return wcShared?.store?.translate(text, params, allowedTag, allowedAttr);
}

export function getRank(rank: string) {
  switch (rank) {
    case 'admin':
      return translate('Administrateur');
    case 'owner':
      return translate('Responsable legal');
    case 'normal':
      return translate('Collaborateur');
    case 'client':
      return translate('Client');
    default:
      return translate('Client');
  }
}

export const ADMIN_TYPE = 'admin';
export const OWNER_TYPE = 'owner';

export const RESTRICT_LEGAL_ENTITY_TYPE = 'restrict';
